import { InputHTMLAttributes } from 'react';

type HiddenFileInputProps = InputHTMLAttributes<HTMLInputElement> & {
  onFiles: (files: File[]) => void;
};

export default function HiddenFileInput({
  onFiles,
  ...rest
}: HiddenFileInputProps) {
  return (
    <input
      type="file"
      style={{ display: 'none' }}
      {...rest}
      onChange={e => {
        if (e.target.files) {
          onFiles(Array.from(e.target.files));
          e.target.value = '';
        }
        rest.onChange?.(e);
      }}
    />
  );
}
